import dispatcher from "../dispatcher"
import _ from "lodash"
import * as api from "../api"
import AppStateStore from "../stores/AppStateStore"
import * as userHelper from "../helpers/userHelper"
import { IUpdatePayrollSettings } from "../models"

export function setRequireAddNewLeaveTracking() {
    dispatcher.dispatch({ type: "REQUIRE_ADD_NEW_LEAVE_TRACKING", data: true })
    dispatcher.dispatch({ type: "REQUIRE_ADD_NEW_LEAVE_TRACKING", data: false })
}

export function setReloadSelfServiceLeaveDashboard() {
    dispatcher.dispatch({ type: "RELOAD_SELF_SERVICE_LEAVE_DASHBOARD", data: true })
    dispatcher.dispatch({ type: "RELOAD_SELF_SERVICE_LEAVE_DASHBOARD", data: false })
}

export function addUser(user) {
    dispatcher.dispatch({ type: "ADDING_USER" })

    api.addUser(user).then(function (response) {
        dispatcher.dispatch({
            type: "ADD_USER",
            object: response.data
        })
    })
}

export function getUserHint(phone) {
    return api.getUserHint(phone)
}

export function recieveAllI9Users(data) {
    dispatcher.dispatch({ type: "RECEIVE_I9_USERS", data: data })
}

export function recieveUserDetail(user) {
    userHelper.checkLoggedInUserPermission(user) &&
        dispatcher.dispatch({ type: "RECEIVE_USER_DETAIL", user: user })
}

export function getLinkedEmployees(accountId, hierarchyItemId, page, limit, search, activeUsers = true) {
    return api.getLinkedEmployees(accountId, hierarchyItemId, page, limit, search, (activeUsers = true)).then((response) => {
        return response.data
    })
}

export function reloadI9Users(accountId, offset = 0, limit = -1, filterText = "") {
    api.getI9Users(accountId, offset / limit, limit, filterText).then(function (response) {
        recieveAllI9Users(response.data)
    })
}

export function clockPinExists(accountId, clockPin) {
    return api.clockPinExists(accountId, clockPin).then(function (response) {
        return response
    })
}

export function externalIdExists(accountId, externalId) {
    return api.externalIdExists(accountId, externalId).then(function (response) {
        return response
    })
}

export function emailExists(email) {
    return api.emailExists(email).then(function (response) {
        return response
    })
}

export function userEmailExists(userId, email) {
    return api.userEmailExists(userId, email).then(function (response) {
        return response
    })
}

export function loadUserDetails(userId, needPageRefresh = true) {
    needPageRefresh && dispatcher.dispatch({ type: "FETCH_USER_DETAILS", userId: userId })
    return api.getUser(userId).then(function (response) {
        recieveUserDetail(response.data)
        needPageRefresh && loadUserStats(userId)
        return response
    })
}

export function loadUser(userId) {
    return api.getUser(userId).then(function (response) {
        return response
    })
}

export function loadUserStats(userId) {
    api.getUserStats(userId).then(function (response) {
        dispatcher.dispatch({
            type: "RECEIVE_USER_STATS",
            stats: response.data
        })
    })
}

export function setUserStatsHours(stats) {
    dispatcher.dispatch({ type: "SET_USER_STATS_HOURS", stats: stats })
}

export function patchUser(userId, user, failedCb: Function = null) {
    return api.patchUser(userId, user)
        .then(() =>
            api.getUser(userId).then(res =>
                recieveUserDetail(res.data)
            )
        )
        .catch(err => {
            AppStateStore.setProgressSnackbarContent(err.response.data.message)
            failedCb && failedCb()
        })
}

export function updatePayrollSettings(userId: string, updatePayrollSettings: IUpdatePayrollSettings) {
    return api.updatePayrollSettings(userId, updatePayrollSettings)
        .then(() => {
            dispatcher.dispatch({ type: "UPDATE_PAYROLL_SETTINGS" })
            api.getUser(userId).then(res =>
                recieveUserDetail(res.data)
            )
        })
        .catch(err => {
            AppStateStore.setProgressSnackbarContent(err.response.data.message)
        })
}

export function patchUserModified(userId, userModified) {
    return api.patchUser(userId, { UserModified: userModified }, userModified).then(() =>
        api.getUser(userId).then(res =>
            recieveUserDetail(res.data)
        )
    )
}

export function updateUser(userId, user, cb = null) {
    return api.updateUser(userId, user).then(function (response) {
        api.getUser(userId).then(function (response) {
            recieveUserDetail(response.data)
            if (cb && typeof cb === "function") cb()
        })
    })
}

export function updateUserProfile(userId, user) {
    return api.patchUser(userId, user)
}

export function deleteFaceSpaces(userId, faceSpaceIds) {
    api.deleteFaceSpaces(faceSpaceIds).then(function (response) {
        loadUserDetails(userId)
    })
}

export function updateProfilePic(userId, faceSpace) {
    dispatcher.dispatch({ type: "UPDATING_USER_PROFILE_PIC" })

    const partialUser = {
        Id: userId,
        ProfileImageID: faceSpace.ImageID,
        ProfileImageS3Url: faceSpace.ImageS3Url
    }

    api.patchUser(userId, partialUser, false).then(function (response) {
        loadUserDetails(userId)
    })
}

export function removeProfilePic(userId) {
    dispatcher.dispatch({ type: "UPDATING_USER_PROFILE_PIC" })

    const partialUser = {
        Id: userId,
        ProfileImageID: "",
        ProfileImageS3Url: ""
    }

    api.patchUser(userId, partialUser, false).then(function (response) {
        loadUserDetails(userId)
    })
}

export function uploadProfilePic(userId, imageData) {
    dispatcher.dispatch({ type: "UPDATING_USER_PROFILE_PIC" })
    api.uploadUserProfilePic(userId, imageData).then(function (response) {
        loadUserDetails(userId)
    })
}

export function openUserProfileDialog() {
    dispatcher.dispatch({ type: "OPEN_USER_PROFILE" })
}

export function closeUserProfileDialog() {
    dispatcher.dispatch({ type: "CLOSE_USER_PROFILE" })
}

export function removePositions(userId, positionIds, cb = null) {
    return api.removeUserPositions(userId, positionIds).then(res => {
        recieveUserDetail(res.data)
        if (cb && typeof cb === "function") cb()
    })
}

export function addPosition(userId, position, cb = null) {
    return api.addEmployeePosition(userId, position).then(res => {
        recieveUserDetail(res.data)
        if (cb && typeof cb === "function") cb()
    })
}

export function updatePosition(userId, position, cb = null) {
    return api.updateEmployeePosition(userId, position).then(res => {
        recieveUserDetail(res.data)
        if (cb && typeof cb === "function") cb()
    })
}

export function addEmployeeAccrual(userId, employeeAccrual, cb = null) {
    return api.addEmployeeAccrual(userId, employeeAccrual)
        .then(res => {
            recieveUserDetail(res.data)
            if (cb && typeof cb === "function") cb();
        })
        .catch(err =>
            AppStateStore.setProgressSnackbarContent(err.response.data.message)
        )
}

export function updateEmployeeAccrual(userId, employeeAccrual, cb = null) {
    return api.updateEmployeeAccrual(userId, employeeAccrual)
        .then(res => {
            recieveUserDetail(res.data);
            if (cb && typeof cb === "function") cb()
        })
        .catch(err =>
            AppStateStore.setProgressSnackbarContent(err.response.data.message)
        )
}

export function addManualEmployeeAccrual(userId, employeeAccrual, cb = null) {
    return api.addManualEmployeeAccrual(userId, employeeAccrual).then(res => {
        recieveUserDetail(res.data)
        if (cb && typeof cb === "function") cb();
    })
}

export function updateManualEmployeeAccrual(userId, employeeAccrual, cb = null) {
    return api.updateManualEmployeeAccrual(userId, employeeAccrual).then(res => {
        recieveUserDetail(res.data);
        if (cb && typeof cb === "function") cb()
    })
}

export function deleteEmployeeAccrual(userId, employeeAccrualId, cb = null) {
    return api.deleteEmployeeAccrual(userId, employeeAccrualId).then(res => {
        if (res.data) {
            recieveUserDetail(res.data);
            if (cb && typeof cb === "function") cb(true)
        }
        else {
            if (cb && typeof cb === "function") cb(false)
        }
    })
}

export function setLeaveTrackingStateFilter(_data) {
    dispatcher.dispatch({ type: "UPDATE_EMPLOYEE_LEAVE_TRACKING_STATE_FILTER", data: _data })
}

export function setLeaveTrackingDateFilter(_data) {
    dispatcher.dispatch({ type: "UPDATE_EMPLOYEE_LEAVE_TRACKING_DATE_FILTER", data: _data })
}

export function setLeaveTrackingOffset(_data) {
    dispatcher.dispatch({ type: "UPDATE_EMPLOYEE_LEAVE_TRACKING_OFFSET", data: _data })
}

export function setLeaveTrackingLimit(_data) {
    dispatcher.dispatch({ type: "UPDATE_EMPLOYEE_LEAVE_TRACKING_LIMIT", data: _data })
}

export function setLeaveTrackingSearchText(_data) {
    dispatcher.dispatch({ type: "UPDATE_EMPLOYEE_LEAVE_TRACKING_SEARCH", data: _data })
}

export function getAllHolidays(userId) {
    api.GetAllHolidaysForEmployee(userId).then(res =>
        dispatcher.dispatch({ type: "UPDATE_EMPLOYEE_HOLIDAYS", data: res.data })
    )
}